import { useSyncExternalStore } from 'react';

function subscribeToMediaQuery(query: string, onChange: () => void): () => void {
  const mql = window.matchMedia(query);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

/**
 * True once the viewport/system matches `query`. Promoted out of
 * command-palette.tsx (FRONT-907, its second caller) — that file's own
 * comment flagged promotion as the right move once a second one showed up.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => subscribeToMediaQuery(query, onChange),
    () => window.matchMedia(query).matches,
    // Server/static render (no `window`): the desktop answer is "no match".
    () => false,
  );
}

/** True when the user has requested reduced motion at the OS/browser level. */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)');
}
